import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isNumber from "lodash/isNumber";

var _DRIVER_GROUP_CONFIG;

import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { formatCurrency, formatPercent } from '@nerdwallet/nw-client-lib/num';
import { DEFAULT_DRIVER_GROUP, getDrivers } from '../../utils';

/**
 * Export all the keys of overridable driverGroups
 */
export var DRIVER_GROUPS_PERSONAL_LOANS = {
  PL_PREQUAL_SBSC_DRIVERS: 'PL_PREQUAL_SBSC_DRIVERS',
  PL_STATIC_SBSC_DRIVERS: 'PL_STATIC_SBSC_DRIVERS'
};
/**
 * @param {Object} args -
 * @param {Object} args.marketplaceEntity -
 * @returns {Object[]} - list of quick-fact objects.
 */

var getDefaultDrivers = function getDefaultDrivers(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return [quickFactMappings.personalLoans.getQuickFactMinCreditScore(marketplaceEntity), quickFactMappings.personalLoans.getQuickFactEstimatedAPR(marketplaceEntity), quickFactMappings.personalLoans.getQuickFactLoanAmount(marketplaceEntity)];
};
/**
 * @param {Object} args -
 * @param {Object} args.marketplaceEntity -
 * @returns {Object[]} - list of PL information
 *
 * SBSC for PL Prequal displays information that isn't part of marketplace.
 * These fields comes from the personal loans Prequal Profile (which in turn comes from prequal-service/personal-loans-service)
 *
 * Because the fields are not from `marketplaceEntity`, we construct our own 'quick-fact'-like objects
 * 1. APR
 * 2. Monthly Payment
 * 3. Total Cost
 * 4. Total loan amount
 * 5. Loan term
 */


var getPrequalSBSCDrivers = function getPrequalSBSCDrivers(_ref2) {
  var additionalEntityData = _ref2.additionalEntityData;
  return [{
    id: 'apr',
    label: 'APR',
    value: (additionalEntityData === null || additionalEntityData === void 0 ? void 0 : additionalEntityData.apr) && formatPercent(additionalEntityData.apr / 100, '0.00%'),
    valueSize: 'medium'
  }, {
    id: 'loanMonthlyPayment',
    label: 'Est. Mo. Payment',
    value: (additionalEntityData === null || additionalEntityData === void 0 ? void 0 : additionalEntityData.loanMonthlyPayment) && formatCurrency(additionalEntityData.loanMonthlyPayment),
    valueSize: 'medium'
  }, {
    id: 'totalCost',
    label: 'Total Cost',
    value: _isNumber(additionalEntityData === null || additionalEntityData === void 0 ? void 0 : additionalEntityData.totalCost) ? formatCurrency(additionalEntityData.totalCost) : 'N/A',
    valueSize: 'medium'
  }, {
    id: 'loanAmount',
    label: 'Loan Amount',
    value: _isNumber(additionalEntityData === null || additionalEntityData === void 0 ? void 0 : additionalEntityData.loanAmount) ? formatCurrency(additionalEntityData.loanAmount) : 'N/A',
    valueSize: 'medium'
  }, {
    id: 'loanTerm',
    label: 'Loan Term',
    value: (additionalEntityData === null || additionalEntityData === void 0 ? void 0 : additionalEntityData.loanTermMonths) && "".concat(additionalEntityData.loanTermMonths, " months"),
    valueSize: 'medium'
  }, {
    id: 'chiclet',
    chicletDataList: additionalEntityData === null || additionalEntityData === void 0 ? void 0 : additionalEntityData.chicletDataList
  }];
}; // Static offers currently have dynamic drivers. Using additionalEntityData to grab the drivers to display


var getStaticSBSCDrivers = function getStaticSBSCDrivers(_ref3) {
  var additionalEntityData = _ref3.additionalEntityData;
  return additionalEntityData.drivers;
};
/**
 * Define config of how to create drivers based off a driverGroup and other props
 */


var DRIVER_GROUP_CONFIG = (_DRIVER_GROUP_CONFIG = {}, _defineProperty(_DRIVER_GROUP_CONFIG, DEFAULT_DRIVER_GROUP, getDefaultDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_PERSONAL_LOANS.PL_PREQUAL_SBSC_DRIVERS, getPrequalSBSCDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_PERSONAL_LOANS.PL_STATIC_SBSC_DRIVERS, getStaticSBSCDrivers), _DRIVER_GROUP_CONFIG);
export default (function (_ref4) {
  var additionalEntityData = _ref4.additionalEntityData,
      driverGroup = _ref4.driverGroup,
      marketplaceEntity = _ref4.marketplaceEntity;
  return {
    drivers: getDrivers({
      driverGroupConfig: DRIVER_GROUP_CONFIG,
      driverGroup: driverGroup,
      marketplaceEntity: marketplaceEntity,
      additionalEntityData: additionalEntityData
    })
  };
});